import { forwardRef } from 'react';

import { IconProps } from '.';

export const SidebarCollapseIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 1024 1024" ref={ref} {...props} {...{ className }}>
      <path
        d="M718.351 411.153c14.996-14.996 14.996-39.31 0-54.306s-39.306-14.996-54.303 0l-128 128c-14.996 14.996-14.996 39.308 0 54.304l128 128c14.996 14.996 39.306 14.996 54.303 0s14.996-39.306 0-54.303l-100.844-100.849 100.844-100.847z"
        fill="currentColor"
      />
      <path
        d="M230.4 153.6h563.2c70.692 0 128 57.308 128 128v460.8c0 70.692-57.308 128-128 128h-563.2c-70.692 0-128-57.308-128-128v-460.8c0-70.692 57.308-128 128-128zM793.6 230.4h-358.4v563.2h358.4c28.278 0 51.2-22.922 51.2-51.2v-460.8c0-28.277-22.922-51.2-51.2-51.2zM230.4 230.4c-28.277 0-51.2 22.923-51.2 51.2v460.8c0 28.278 22.923 51.2 51.2 51.2h128v-563.2h-128z"
        fill="currentColor"
      />
    </svg>
  );
});

export default SidebarCollapseIcon;
